import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useResults = ({ page, courseGroups, userGroup, challenge, status, enabled = true }) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['results', { page, courseGroups, userGroup, challenge, status }],
    queryFn: async () => {
      const requestData = {
        page,
        courseGroups,
        userGroup,
        challengeType: challenge
      };
      
      // Only include status if it's not "all"
      if (status !== 'all') {
        requestData.status = status;
      }
      
      const result = await restClient({ 
        url: `${prefix}/results`, 
        method: 'post',
        data: requestData
      });
      return result;
    },
    enabled,
    staleTime: 0,
    cacheTime: 0, 
    refetchOnWindowFocus: false,
  });
};
